import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProfileCard from '../../../components/ProfileCard/ProfileCard'
import Profiledetails from './Profiledetails';
import ViewSlots from './ViewSlots'
import Settings from './Settings';
import './MnMyProfileStyle.css'
import Billing from './Billing';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addMentorAvailableSlots, changePassword, clearSlotDates, clearSlots, clearState, deleteMentorInterviewSlot, getInterestsAndTopics, getMentorAvailableDates, getMentorSlotsByDate, getParticularUser, mentorData, updateUserDetails } from '../../../reducer/mentorSlice';
import PageLoader from '../../../components/loaders/PageLoader/PageLoader';
import moment from 'moment';
import AddSlotPopup from '../../../components/Popups/AddSlotPopup/AddSlotPopup';
import ErrorToast from "../../../components/Toast/ErrorToast";
import SuccessToast from "../../../components/Toast/SuccessToast";
import Deletepoup from '../../../components/Popups/Deletepoup/Deletepoup';
import Skeleton from 'react-loading-skeleton';
import * as filestack from 'filestack-js';

function AdMyProfile() {

    //Add Slot Templates
    const now = new Date(moment().hour(0).minute(0).second((0)));
    const format = "h:mm a";
    const daysInAWeek = ["sun", "mon", "tue", "wed", "thur", "fri", "sat"];

    const timeRangeCountTemplate = {
        mon: [0],
        tue: [0],
        wed: [0],
        thur: [0],
        fri: [0],
        sat: [0],
        sun: [0],
    };

    const interviewTimeTemplate = {
        sun: [{ from: now, to: now }],
        mon: [{ from: now, to: now }],
        tue: [{ from: now, to: now }],
        wed: [{ from: now, to: now }],
        thur: [{ from: now, to: now }],
        fri: [{ from: now, to: now }],
        sat: [{ from: now, to: now }]
    };

    //Edit Profile states
    const editProfileTemplate = {
        profileImg: {
            name: "",
            url: "",
        },
        firstName: "",
        lastName: "",
        about: "",
        designation: "",
        company: "",
        mobileNumber: "",
        email: "",
        linkedin: "",
        interests: [],
        topics: [],
        languages: [],
        yrsOfExp: "",
    };

    const errorEditProfileTemplate = {
        firstName: "",
        lastName: "",
        designation: "",
        company: "",
        mobileNumber: "",
        email: "",
        linkedin: "",
        interests: "",
        topics: "",
        yrsOfExp: "",
    };

    //Change pass templates
    const changePassTemplate = {
        password: "",
        newPassword: "",
        confirmPassword: "",
    }

    //Filter templates
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const months = [moment().month(), moment().add(1, "months").month(), moment().add(2, "months").month(), moment().add(3, "months").month(), moment().add(4, "months").month(), moment().add(5, "months").month(), moment().add(6, "months").month(), moment().add(7, "months").month(), moment().add(8, "months").month(), moment().add(9, "months").month(), moment().add(10, "months").month(), moment().add(11, "months").month()];

    //Mentor Slots
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");

    //delete slot
    const [deleteToggler, setDeleteToggler] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState("");

    //Add Slots States
    const [dateRange, setDateRange] = useState({
        from: "",
        to: ""
    });
    const [selectedWeekDays, setSelectedWeekDays] = useState([]);
    const [timeRangeCount, setTimeRangeCount] = useState(timeRangeCountTemplate);
    const [interviewTime, setInterviewTime] = useState(interviewTimeTemplate);

    //Edit Profile States
    const [editProfile, setEditProfile] = useState(editProfileTemplate);
    const [topicOptions, setTopicOptions] = useState([]);
    const [topics, setTopics] = useState([]);
    const [interestOptions, setInterestOptions] = useState([]);
    const [interests, setInterests] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [errorEditProfile, setErrorEditProfile] = useState(errorEditProfileTemplate);

    const [TabSlotProfile, setTabSlotProfile] = useState(1)
    const [addSlotPopupToggler, setAddSlotPopupToggler] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    //ChangePassword States
    const [changePassToggler, setChangePassToggler] = useState(1);
    const [password, setPassword] = useState(changePassTemplate);
    const [errorPassword, setErrorPassword] = useState(changePassTemplate);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    const [isShowSuccess, setIsShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isLoaderFetching, isFetching, isSlotsFetching, isSlotDatesFetching, isSuccess, isError, errorMessage, particularUser, mentorSlotDates, mentorSlots, interestTopics } = useSelector(mentorData);

    const handleClickEditProfile = () => {
        setTabSlotProfile(4);
    };

    //Add Slot Functions
    const handleAddSlotsChange = (e) => {
        if (e) {
            setDateRange({
                from: e[0],
                to: e[1]
            })
        }
    }

    const handleCheckboxToggle = (day) => {
        if (day === "sun") return;
        if (selectedWeekDays.includes(day)) setSelectedWeekDays(prev => prev.filter(item => item !== day))
        else setSelectedWeekDays(prev => [...prev, day]);
    };

    const handleTimeFromChange = (e, type, i) => {
        const value = e;
        const timeSlot = interviewTime[type];
        timeSlot[i].from = value;
        setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
    };

    const handleTimeToChange = (e, type, i) => {
        const value = e;
        const timeSlot = interviewTime[type];
        timeSlot[i].to = value;
        setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlot] }));
    };

    const handleTimeSlotRemove = (type, index) => {
        if (interviewTime[type].length === 1) {
            setSelectedWeekDays(prev => prev.filter(day => day !== type));
        }
        else {
            const timeSlots = interviewTime[type];
            const timeSlot = timeRangeCount[type];
            timeSlot.splice(index, 1);
            timeSlots.splice(index, 1);
            setTimeRangeCount((prev) => ({ ...prev, [type]: [...timeSlot] }));
            setInterviewTime((prev) => ({ ...prev, [type]: [...timeSlots] }));
        }
    };

    const validate = () => {
        if (dateRange.from === "" || dateRange.to === "") return "date";
        if (selectedWeekDays.length === 0) return "noSlot";
        let check = "";
        selectedWeekDays.forEach((day) => {
            if (day === "sun") return;
            interviewTime[day].forEach((time) => {
                if ((moment(time.from).format("HH") < 10 || moment(time.to).format("HH") < 10) || (moment(time.from).format("HH") > 22 || moment(time.to).format("HH") > 22)) {
                    check = "new";
                }
                if ((new Date(time.from).getTime() + 1200000) > new Date(time.to).getTime()) {
                    check = "time";
                };
            })
        })
        return check;
    };

    const handleAddSlots = () => {
        if (validate()) {
            if (validate() === "date") {
                setIsShowError(true);
                setErrMessage("Please select a date range!");
            }
            if (validate() === "time") {
                setIsShowError(true);
                setErrMessage("Time slots should have atleast 20 min difference!")
            }
            if (validate() === "noSlot") {
                setIsShowError(true);
                setErrMessage("Please select a day for availablity!")
            }
            if (validate() === "new") {
                setIsShowError(true);
                setErrMessage("Please select time between 10am - 10pm")
            }
        }
        else {

            let obj;
            obj = interviewTime;
            for (const day in interviewTime) {
                if (!selectedWeekDays.includes(day)) {
                    obj = { ...obj, [day]: [] }
                    // delete obj[day];
                }
                else {
                    const din = obj[day];
                    din.map((time) => {
                        time.from = moment(time.from).format("HH:mm:ss");
                        time.to = moment(time.to).format("HH:mm:ss")
                    });
                    obj = { ...obj, [day]: [...din] }
                }
            }
            const object = {
                mentorId: localStorage.getItem("userId"),
                dateRange: dateRange,
                interviewTime: obj
            }
            dispatch(addMentorAvailableSlots(object));
            setTimeRangeCount(timeRangeCountTemplate);
            setInterviewTime(interviewTimeTemplate);
        }

    };

    const handleAddSlotsDiscard = () => {
        setSelectedWeekDays("");
        setDateRange({ from: "", to: "" });
        setTimeRangeCount(timeRangeCountTemplate);
        setInterviewTime(interviewTimeTemplate);
    };

    const handleAddSlotsClose = () => {
        setSelectedWeekDays("");
        setDateRange({ from: "", to: "" });
        setTimeRangeCount(timeRangeCountTemplate);
        setInterviewTime(interviewTimeTemplate);
        setAddSlotPopupToggler(false);
    };

    //Edit Profile Functions
    const handleEditProfileChange = (e) => {
        // setErrorAddMentor(errorTemplate);
        const { name, value } = e.target;
        if (name === "mobileNumber" && (value?.length > 10 || value < 0)) return;
        setEditProfile((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleEditProfileDropdownChange = (e) => {
        setErrorEditProfile(errorEditProfileTemplate);
        const { name, value } = e.target;
        setEditProfile(prev => ({
            ...prev,
            [name]: [value]
        }));

    }

    const handleEditProfileUpload = () => {
        const client = filestack.init("AASYllbvHQ3u0A1GxbOvZz");

        client.picker({
            accept: ['image/*'],
            onUploadDone: (result) => {
                if (result?.filesFailed?.length > 0) {
                    setIsShowError(true);
                    setErrMessage("Something went wrong")
                }
                if (result?.filesUploaded?.length > 0) {
                    console.log(result?.filesUploaded[0]?.url)
                    setEditProfile(prev => ({
                        ...prev,
                        profileImg: result?.filesUploaded[0]?.url
                    }));
                }
            },
        }).open();
    };

    // const editProfileValidation = () => {
    //     for (const key in errorEditProfile) {
    //       if (!editProfile[key]) {
    //         if (key === "lastName") continue;
    //         setErrorEditProfile((prev) => ({
    //           ...prev,
    //           [key]: "This field is mandatory",
    //         }));
    //         return true;
    //       }
    //     }
    //   };

    const handleEditProfileSave = () => {
        const arr = editProfile;
        arr["interests"] = interests?.map(item => item.value);
        arr["topics"] = topics?.map(item => item.value);
        arr["languages"] = languages;
        setTabSlotProfile(1);
        dispatch(updateUserDetails(arr));
    };

    //Change Password Functions
    const handleShowChangePass = () => {
        setChangePassToggler(2);
    };

    const handleCancelChangePass = () => {
        setPassword(changePassTemplate);
        setErrorPassword(changePassTemplate);
        setChangePassToggler(1);
    }

    const handlePassChange = (e) => {
        setErrorPassword(changePassTemplate);
        const { name, value } = e.target;
        setPassword(prev => ({
            ...prev,
            [name]: value
        }))
    };

    const validatePassword = () => {
        for (const key in password) {
            if (!password[key]) {
                setErrorPassword(prev => ({
                    ...prev,
                    [key]: "Please fill this field"
                }));
                return true;
            }
        }
        if (password["confirmPassword"] !== password["newPassword"]) {
            setErrorPassword(prev => ({
                ...prev,
                confirmPassword: "Password do not match!"
            }));
            return true;
        }
        if (password["newPassword"].length < 6) {
            setErrorPassword(prev => ({
                ...prev,
                newPassword: "Password should be atleast 6 digit long!"
            }));
            return true;
        }
        return false;
    };

    const handlePassChangeConfirm = () => {
        if (!validatePassword()) {
            dispatch(changePassword(password));
        }
    };

    const handlePassPressConfirm = (e) => {
        if (e.key === "Enter") {
            if (!validatePassword()) {
                dispatch(changePassword(password));
            }
        }
    };

    //Filter functions
    const handleDateFilter = (e) => {
        dispatch(clearSlots());
        const { value } = e.target;
        setSelectedMonth(value);
        const year = moment().year();
        const month = monthNames[value];
        const date = moment(`${year}-${month}-01`).format("YYYY-MM-DD");
        if (monthNames[moment().month()] === month) dispatch(getMentorAvailableDates())
        else dispatch(getMentorAvailableDates(date));
        // dispatch(getMentorAvailableDates(date));
    };

    //Delete slot
    const handleDeletePopup = (id) => {
        setSelectedSlot(id);
        setDeleteToggler(true);
    };

    const handleDeleteMentor = () => {
        dispatch(deleteMentorInterviewSlot(selectedSlot));
    };

    const handleCloseDelete = () => {
        setSelectedSlot("");
        setDeleteToggler(false);
    };

    useEffect(() => {
        dispatch(getParticularUser({ user: "mentor", userId: localStorage.getItem("userId") }));
        return () => {
            dispatch(clearSlotDates());
            dispatch(clearSlots());
        }
    }, []);

    useEffect(() => {
        dispatch(clearSlots());
        setSelectedMonth(months[0])
        setSelectedDate("");
        if (TabSlotProfile === 2) dispatch(getMentorAvailableDates(selectedDate));
        if (TabSlotProfile === 4) dispatch(getInterestsAndTopics());
    }, [TabSlotProfile]);

    //GetSlot useEffect
    useEffect(() => {
        if (selectedDate) {
            dispatch(getMentorSlotsByDate(selectedDate));
        }
    }, [selectedDate]);

    useEffect(() => {
        if (mentorSlotDates?.length > 0) {
            setSelectedDate(mentorSlotDates[0]?.slotsDate)
        }
    }, [mentorSlotDates])

    //AddSlot useEffect
    useEffect(() => {
        const InBetweenDays = Math.abs((new Date(dateRange.from).getTime() - new Date(dateRange.to).getTime()) / (1000 * 60 * 60 * 24));
        if (dateRange.to !== "") {
            if (InBetweenDays <= 6) {
                setSelectedWeekDays([]);
                for (let i = 0; i <= InBetweenDays; i++) {
                    if (i > 6) break;
                    const day = new Date(moment(dateRange.from).add(i, "day")).getDay();
                    if (day === 0) continue;
                    setSelectedWeekDays(prev => [...prev, daysInAWeek[day]]);
                }
            }
            else {
                setSelectedWeekDays(daysInAWeek.filter(item => item !== "sun"));
            }
        }
    }, [dateRange]);

    //Edit Profile Use Effect 
    useEffect(() => {
        if (interestTopics && Object.keys(interestTopics)?.length > 0) {
            setTopicOptions(interestTopics?.topics?.map(item => {
                return {
                    label: item?.Topic,
                    value: item?.id
                }
            }))
            setInterestOptions(interestTopics?.interests?.map(item => {
                return {
                    label: item?.interest,
                    value: item?.id
                }
            }))
        }
    }, [interestTopics])

    useEffect(() => {
        setEditProfile({
            profileImg: particularUser?.profileImg,
            firstName: particularUser?.firstName,
            lastName: particularUser?.lastName,
            about: particularUser?.about,
            designation: particularUser?.profession?.designation,
            company: particularUser?.profession?.company,
            mobileNumber: particularUser?.mobileNumber,
            email: particularUser?.email,
            linkedin: particularUser?.linkedin,
            // interests: particularUser?.interests?.length > 0 ? [particularUser?.interests[0]?.interest] : [],
            // topics: particularUser?.topics?.length > 0 ? [particularUser?.topics[0]?.Topic] : [],
            yrsOfExp: particularUser?.profession?.yrsOfExp,
        });
        let arr1 = [];
        let arr2 = [];
        particularUser?.interests?.map((item) => {
            arr1.push({
                label: item?.interest,
                value: item?.id,
            })
        });
        particularUser?.topics?.map((item) => {
            arr2.push({
                label: item?.Topic,
                value: item?.id,
            })
        });
        setInterests([...arr1]);
        setTopics([...arr2]);
        particularUser?.languages?.length > 0 && setLanguages(particularUser?.languages?.map((item) => item?.name))
    }, [particularUser]);

    useEffect(() => {
        if (isSuccess) {
            // setPassword(changePassTemplate);
            // setErrorPassword(changePassTemplate);
            setIsShowSuccess(true);
            setSuccessMessage("Success");
            setChangePassToggler(1);
            setTabSlotProfile(1);
            setAddSlotPopupToggler(false);
            setDeleteToggler(false);
            setDateRange({
                from: "",
                to: ""
            });
            setSelectedWeekDays([]);
            setSelectedDate("");
            setSelectedSlot("");
            setSelectedMonth(months[0]);
            dispatch(getParticularUser({ user: "mentor", userId: localStorage.getItem("userId") }));
            dispatch(clearSlots());
            dispatch(clearState());
            dispatch(clearSlotDates());
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError) {
            setIsShowError(true);
            setErrMessage(errorMessage);
            dispatch(clearState());
        }
    }, [isError]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <ErrorToast
                show={isShowError}
                setShow={() => setIsShowError(false)}
                message={errMessage}
            />
            <SuccessToast
                show={isShowSuccess}
                setShow={() => setIsShowSuccess(false)}
                message={successMessage}
            />
            <Deletepoup isActive={deleteToggler} handleClose={handleCloseDelete} handleDelete={handleDeleteMentor} />
            <AddSlotPopup isActive={addSlotPopupToggler} handleClose={handleAddSlotsClose} dateRange={Object.values(dateRange)} setIsActive={setAddSlotPopupToggler} onChange={handleAddSlotsChange} now={now} format={format} daysInAWeek={daysInAWeek} selectedWeekDays={selectedWeekDays} interviewTime={interviewTime} setInterviewTime={setInterviewTime} timeRangeCount={timeRangeCount} setTimeRangeCount={setTimeRangeCount} handleCheckboxToggle={handleCheckboxToggle} handleTimeFromChange={handleTimeFromChange} handleTimeToChange={handleTimeToChange} handleTimeSlotRemove={handleTimeSlotRemove} handleSave={handleAddSlots} handleDiscard={handleAddSlotsDiscard} />
            <section className=''>
                <div className="DashboardWrapper">
                    <div className="headingprofilewrap">
                        <h2 className='heading-2'>My Profile</h2>
                    </div>

                    <div className="flex-col Allcardboxwrapper mt-30">
                        <div className="profilewrapper w-100 ">
                            <div className="Adprofiledatawrapper flex-start">
                                {isFetching ? <Skeleton width={"150px"} height={"150px"} circle /> : <div className='Imageboxall'>
                                    <img src={particularUser?.profileImg ? particularUser?.profileImg : "/assets/img/user2.jpeg"} alt="" />
                                </div>}
                                <div className="AdProfileDetailsarea">
                                    <div className="headingwrap">
                                        <div className="headingorg flex gap-10">
                                            <h2 className='heading-2'>{isFetching ? <Skeleton width={"200px"} /> : particularUser?.firstName ? `${particularUser?.firstName} ${particularUser?.lastName}` : "---"}</h2>
                                            {particularUser?.linkedin && <Link to={particularUser?.linkedin} target='_blank' className='linkedintext'>
                                                <span className='flex gap-2'>
                                                    Linkedin
                                                    <img src="/assets/img/send.png" alt="" />
                                                </span>
                                            </Link>}
                                        </div>
                                        <div className="AdPsnlDetailsMentors mt-10">
                                            {isFetching ? <Skeleton width={"200px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/usermentor.png" alt="" />
                                                </span>
                                                <p className="text2">{particularUser?.profession?.designation ? particularUser?.profession?.designation : "---"}, {particularUser?.profession?.company ? particularUser?.profession?.company : "---"}</p>
                                            </div>}
                                            {isFetching ? <Skeleton width={"160px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/emailprofile.png" alt="" />
                                                </span>
                                                <p className="text2">{particularUser?.email ? particularUser?.email : "---"}</p>
                                            </div>}
                                            {isFetching ? <Skeleton width={"100px"} height={"10px"} /> : <div className="AdMentorSubDetails f-items-center">
                                                <span className="flex-center">
                                                    <img src="/assets/img/contact/callprofile.png" alt="" />
                                                </span>
                                                <p className="text2">{particularUser?.mobileNumber ? particularUser?.mobileNumber : "---"}</p>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="AdCardsProfilWrapper flex gap-10 mt-40">
                                        {isFetching ?
                                            <div className={`CardContactWrapper`}>
                                                <span className='Adicontoolsicons flex-center'>
                                                    {<Skeleton width={"50px"} height={"50px"} circle />}
                                                </span>
                                                <div className="contentareacontact">
                                                    <Skeleton width={"30px"} height={"20px"} />
                                                    <Skeleton width={"60px"} height={"10px"} />
                                                </div>
                                            </div>
                                            : <ProfileCard number={particularUser?.noOfCalls ?? 0} text={'Delivered Solutions'} img={"/assets/img/yellowcall.png"} />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="AdMenusTabWrapper w-100 mt-40 menteefixmenu">
                            <ul className='flex gap-30 items-center'>
                                <li onClick={() => setTabSlotProfile(1)} className={TabSlotProfile === 1 && 'active'}>Profile Details</li>
                                <li onClick={() => setTabSlotProfile(2)} className={TabSlotProfile === 2 && 'active'}>View Slots</li>
                                {/* <li onClick={() => setTabSlotProfile(3)} className={TabSlotProfile === 3 && 'active'}>Billing</li> */}
                                <li onClick={() => setTabSlotProfile(4)} className={TabSlotProfile === 4 && 'active'}>Settings</li>
                            </ul>
                        </div>

                    </div>

                </div>

                <Profiledetails isActiveTab={TabSlotProfile === 1 && 'active'} handleClickEditProfile={handleClickEditProfile} data={particularUser} isFetching={isFetching} />
                <ViewSlots isFetching={isSlotDatesFetching} isSlotsFetching={isSlotsFetching} isActiveTab={TabSlotProfile === 2 && 'active'} selectedMonth={selectedMonth} setAddSlotPopupToggler={setAddSlotPopupToggler} selectedDate={selectedDate} setSelectedDate={setSelectedDate} slotDates={mentorSlotDates} slots={mentorSlots} monthNames={monthNames} months={months} handleDateFilter={handleDateFilter} handleDeletePopup={handleDeletePopup} />
                {/* <Billing isActiveTab={TabSlotProfile === 3 && 'active'} /> */}
                <Settings isActiveTab={TabSlotProfile === 4 && 'active'} interestOptions={interestOptions} topicOptions={topicOptions} interests={interests} setInterests={setInterests} topics={topics} setTopics={setTopics} languages={languages} setLanguages={setLanguages} editProfile={editProfile} handleChange={handleEditProfileChange} handleUploadProfile={handleEditProfileUpload} handleDropdownChange={handleEditProfileDropdownChange} handleEditProfileSave={handleEditProfileSave} isError={errorEditProfile} changePassToggler={changePassToggler} password={password} errorPassword={errorPassword} handlePassChange={handlePassChange} handleShowChangePass={handleShowChangePass} handleCancelChangePass={handleCancelChangePass} handlePassChangeConfirm={handlePassChangeConfirm} handlePassPressConfirm={handlePassPressConfirm} />
            </section>
        </>
    )
}

export default AdMyProfile